/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 11
// module chunks = 0